/**
 * Copyright Mántum All Rights Reserved.
 */
import Component from '../../dropdown/row';
import type { Option } from '../type';

type PropTypes = {
    onClick?: (value: Option) => void;
    value: Option;
};

export default function Row(props: PropTypes) {
    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.value);
        }
    };

    return (
        <Component key={props.value.id} onClick={onClick}>
            {props.value.name}
        </Component>
    );
}
